<script lang="ts">let { size = "20" } = $props();
</script>

<svg height={size} style="fill:currentColor" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M4 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-6a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
	/>
	<path
		clip-rule="evenodd"
		d="M0 3a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3zm20 3v13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6z"
		fill-rule="evenodd"
	/>
</svg>
